import { FC } from "react";
import { useQuery } from "react-query";
import ReactFlagsSelect from "react-flags-select";
import { APIResponse, API_URL_V1, get } from "../api";
import { Country } from "../@types";

const CountryInput: FC<{
  onSelect: (countryCode: string) => void;
  selected: string;
  allowedCountries?: string[];
}> = ({ onSelect, selected, allowedCountries }) => {

  /**
   * `/country_list` is registered under the v1 prefix only (routes/api.php,
   * inside `Route::prefix('v1')`). This was hitting `${API_URL}/country_list`
   * — i.e. /api/v2/country_list — which does not exist, so the query always
   * errored and `disabled={isError || isLoading}` left the picker permanently
   * greyed out reading "Error fetching countries".
   */
  const { data } = useQuery<APIResponse<Country[]>>(
    "countries",
    () => get(API_URL_V1 + "/country_list"),
  );
  // Read cached query data directly: onSuccess does not run on every remount.
  const countryData = data?.data;
  const countries = Array.isArray(countryData) ? countryData : [];
  const codes = countries.map(country => country.country_key.toUpperCase());

  return (
    <ReactFlagsSelect
      selected={selected}
      onSelect={onSelect}
      className="max-w-md w-full"
      countries={allowedCountries ?? (codes.length ? codes : undefined)}
      searchable
      placeholder="Select Country"
      selectButtonClassName="rounded-xl"
    />
  );
};

export default CountryInput;
